import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserCheckIn, getUserCheckInHistory, getUserCheckInSummary } from "store/services/checkIn";

export const GetAllUserCheckIn = createAsyncThunk(
  "checkIn/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserCheckIn(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetAllUserCheckInSummary = createAsyncThunk(
  "checkInSummary/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserCheckInSummary(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserCheckInHistory = createAsyncThunk(
  "checkInHistory/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserCheckInHistory(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
